

export default () => {
    apos.util.widgetPlayers.recruiterDetails = {
        selector : "#recruiter-page-content",
        player: function (recruiterDetails) {
          console.log("recruiter profile client side");

          // var shareLink = null;
          // var shareCMSLink = null;
          // var mode = null;

          window.addEventListener('load', () => {
          const urlParams = new URLSearchParams(window.location.search);
          const shouldScroll = urlParams.get('submit') === 'true';
            if (shouldScroll) {
              const resumeWidget = document.querySelector('#resume-form-widget');
              resumeWidget.style.display = 'block';
              resumeWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });

              urlParams.delete('submit');
              const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
              window.history.replaceState({}, document.title, newUrl);
            }
          });


          // refer a fried component

          const referAfriendpage = document.querySelector("#refer-a-friend");
          console.log("referAfriendpage",referAfriendpage);
          if(referAfriendpage){
            const rafButton = referAfriendpage.querySelector('a[href="#"]');
            const rafwidget = document.querySelector('.refer-friend-widget-container');
            if (rafButton && rafwidget) {
              rafButton.addEventListener('click', function () {
                      console.log("on click of RAF");
                      rafwidget.style.display = rafwidget.style.display === 'none' || !rafwidget.style.display
                      ? 'block'
                      : 'none';
                      rafwidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });
            };         
          }
          
          //signup component

          const candidateSignupPage = document.querySelector("#candidateSignup");
          console.log("candidateSignupPage",candidateSignupPage);
          if(candidateSignupPage){
            const candidatebutton = candidateSignupPage.querySelector('a[href="#"]');
            const widgetContainer = document.querySelector('.refer-widget-container');
             if (candidatebutton && widgetContainer) {
              candidatebutton.addEventListener('click', function () {
                      console.log("on click of join talent community");
                      widgetContainer.style.display = widgetContainer.style.display === 'none' ? 'block' : 'none';
                      widgetContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
              });
            }
          }

          // recruiter detils
          const recruiterProfile = document.querySelector("#rec-profile")
          if(recruiterProfile){
            console.log("recruiter profil...........e",recruiterProfile);
            const openBtn = document.querySelector('#recruiter-summary-open');
            const overlay = document.querySelector('.recruiter-popup-overlay');
            const closeBtn = document.querySelector('.recruiter-popup-close');
          
            if (openBtn && overlay && closeBtn) {
              openBtn.addEventListener('click', function (e) {
                e.preventDefault();
                overlay.style.display = 'flex';
              });
          
              closeBtn.addEventListener('click', function () {
                overlay.style.display = 'none';
              });
          
              window.addEventListener('click', function (e) {
                if (e.target === overlay) {
                  overlay.style.display = 'none';
                }
              });
            }

            const rfrbutton = document.querySelector("#refer-friend-scroll");
            const autoShowRAF = rfrbutton ? rfrbutton.dataset.autoShow === 'true' : false;
            const rafButton = document.querySelector('#refer-a-friend-open');
            const rafwidget = document.querySelector('.refer-friend-widget-container');
            if(rfrbutton){
              if (autoShowRAF) {
                rfrbutton.addEventListener('click', function () {
                  if (rafButton) rafButton.style.display = 'none';
                  if (rafwidget) rafwidget.style.display = 'block';
                  rafwidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
              }else{
                  if (rafwidget) {
                        rfrbutton.addEventListener('click', function () {
                          // Always ensure it's visible
                          if (rafwidget.style.display === 'none' || !rafwidget.style.display) {
                            rafwidget.style.display = 'block';
                          }

                          // Scroll to it regardless
                          rafwidget.scrollIntoView({ behavior: 'smooth', block: 'start' });

                                console.log("on click of RAF");
                                // rafwidget.style.display = rafwidget.style.display === 'none' || !rafwidget.style.display
                                // ? 'block'
                                // : 'none';
                                // rafwidget.scrollIntoView({ behavior: 'smooth', block: 'start' });

                            
                       });
                  }
              }
            }

            // const recruiterShare = document.querySelector("#recruiter-share")
            // if(recruiterShare){
            //   var data = recruiterShare.dataset;
            //   shareLink = data["link"];
            //   var url = window.location.href.split("?");
            //   shareCMSLink =url[0] ;
            //   // const data2 = document.getElementById("api-data").dataset;
            //   mode = data["sharemode"];
            // }

            // const faceBook = document.querySelector(".faceBookIcon");
            // if(faceBook){
            //     faceBook.addEventListener("click", onShareLink);
            //     async function onShareLink() {
            //       console.log("fb URl", "https://www.facebook.com/sharer/sharer.php?u="+ encodeURIComponent(shareCMSLink +"?utm_source=fb_share&utm_campaign=cms&utm_medium=referral") +  "",
            //         "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
            //       window.open(
            //         "https://www.facebook.com/sharer/sharer.php?u="+ encodeURIComponent(shareCMSLink +"?utm_source=fb_share&utm_campaign=cms&utm_medium=referral") +  "",
            //         "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            //       );
            //     }
              
            // }

            // const linkedIn = document.querySelector(".linkedinIcon")
            // if (linkedIn) {
            //   linkedIn.addEventListener("click", onShareLink);
            //   async function onShareLink() {
            //     console.log("linked in click")
            //     window.open(
            //         "https://www.linkedin.com/shareArticle?mini=true&url=" +
            //         encodeURIComponent( shareCMSLink+"?utm_source=linkedin_share&utm_campaign=cms&utm_medium=referral") +
            //           "&title=",
            //         "",
            //         "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            //       );
            //     }
            // }

            // const twitter = document.querySelector(".twitterIcon");
            // if (twitter) {
            //   twitter.addEventListener("click", onShareLink);
            //   async function onShareLink() {
            //    window.open(
            //         "https://twitter.com/share?url=" + encodeURIComponent(shareCMSLink +"?utm_source=x_share&utm_campaign=cms&utm_medium=referral")+ "",
            //         "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            //       );
            //     }
            //   }
            // }
            
            // const instagram = document.querySelector(".instaIcon");
            // if (instagram) {
            //   instagram.addEventListener("click", function () {
            //     console.log("Instagram clicked");
            //     window.open(
            //       "https://www.instagram.com/shareArticle?mini=true&url=" +
            //       encodeURIComponent(shareCMSLink +"?utm_source=linkedin_share&utm_campaign=cms&utm_medium=referral") +
            //         "&title=",
            //       "",
            //       "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
            //     );
            //   });
            // }
          }     
        }
    }
};